import React from "react";
import cx from "classnames";
import { Image } from "src/components/image";
import { Reveal } from "src/components/reveal";
import styles from "./product-features.module.css";

interface ProductFeaturesProps {
  module: {
    headline?: string;
    features: [
      {
        _key: string;
        graphic: {
          asset: {
            url: string;
          };
        };
        title: string;
      }
    ];
  };
}
export const ProductFeatures = ({ module }: ProductFeaturesProps) => {
  const { headline, features } = module;
  return (
    <div className={cx(styles.productFeatures)}>
      <h2 className={cx("subhead ac", styles.headline)}>{headline}</h2>
      <div className={styles.features}>
        {features &&
          features.map((feature, index) => (
            <Reveal
              delay={(index + 1) * 120}
              key={feature._key}
              className={styles.feature}
            >
              {feature.graphic && (
                <Image
                  className={styles.featureGraphic}
                  src={feature.graphic.asset.url}
                  width={100}
                />
              )}
              <p className={cx("ac body body--small", styles.featureTitle)}>
                {feature.title}
              </p>
            </Reveal>
          ))}
      </div>
    </div>
  );
};
